<template>
  <div>
    <Head title="Dashboard" />

    <h1 class="mb-6 text-2xl font-semibold text-slate-800">Dashboard</h1>

    <!-- Cards -->
    <div class="grid gap-6 mb-10 sm:grid-cols-2 lg:grid-cols-4">
      <StatCard
        v-for="d in datas"
        :key="d.label"
        :label="d.label"
        :value="d.value"
        :trend="d.trend"
        :icon="d.icon"
        :icon-bg="d.iconBg"
        :icon-color="d.iconColor"
      />
    </div>

    <!-- Statistik Pertanggungjawaban -->
    <div v-if="accountabilityStats" class="p-5 bg-white border rounded-lg shadow-sm border-slate-200">
      <h2 class="mb-4 text-lg font-semibold text-slate-800">Statistik Pertanggungjawaban</h2>
      <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard
          v-for="s in accountabilityStats"
          :key="s.label"
          :label="s.label"
          :value="s.value"
          :icon="s.icon"
          :icon-bg="s.iconBg"
          :icon-color="s.iconColor"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import StatCard from '@/Shared/StatCard.vue'

export default {
  components: {
    Head,
    StatCard,
  },
  layout: Layout,

  props: {
    datas: Array,
    accountabilityStats: Array,
  },
}
</script>

